import { apiMapper } from "./ApiMapper";

const TimeSheetAPI = {
  LIST: (axiosPrivate, pageNumber, pageSize) => {
    return axiosPrivate.get(
      `${apiMapper.timesheet.list}?page=${pageNumber}&page_size=${pageSize}`
    );
  },
  MANAGER_TIMESHEET: (axiosPrivate) => {
    return axiosPrivate.get(apiMapper.timesheet.managerTimesheet);
  },
  OVERVIEW: (axiosPrivate, id) => {
    return axiosPrivate.get(`${apiMapper.timesheet.overview}${id}/`);
  },
  TIMESHEETMAINPAGE: (axiosPrivate, payload) => {
    return axiosPrivate.post(apiMapper.timesheet.timesheetMainPage, payload);
  },
  TIMESHEET_APPROVALS: (axiosPrivate, payload) => {
    return axiosPrivate.post(apiMapper.timesheet.timesheetApprovals, payload);
  },
  TIMESHEET_APPROVALS_HR_MANAGER: (axiosPrivate, payload) => {
    return axiosPrivate.post(
      apiMapper.timesheet.timesheetApprovalsHrManager,
      payload
    );
  },
  MANAGER_NOTIFICATION_COUNT: (axiosPrivate, payload) => {
    return axiosPrivate.post(
      apiMapper.timesheet.managerNotificationCount,
      payload
    );
  },
  TIMESHEET_ONGOING_ALLOCATEDHRS: (axiosPrivate, payload) => {
    return axiosPrivate.post(
      apiMapper.timesheet.timesheetOngoingAllocatedHrs,
      payload
    );
  },
  ADD_TIMESHEET: (axiosPrivate, payload) => {
    return axiosPrivate.post(apiMapper.timesheet.addTimesheet, payload);
  },
  EMP_TIMESHEET_WEEKWISE_STATUSLIST: (
    axiosPrivate,
    payload,
    pageNumber,
    pageSize
  ) => {
    return axiosPrivate.post(
      `${apiMapper.timesheet.empTimesheetWeekwiseStatusList}?page=${pageNumber}&page_size=${pageSize}`,
      payload
    );
  },
  EMP_TIMESHEET_TOTALUNPLANNED_HRS_LIST: (
    axiosPrivate,
    payload,
    pageNumber,
    pageSize
  ) => {
    return axiosPrivate.post(
      `${apiMapper.timesheet.empTimesheetTotalUnplannedHrsList}?page=${pageNumber}&page_size=${pageSize}`,
      payload
    );
  },
  EMP_TIMESHEET_TOTALTIMEOFF_HRS_LIST: (
    axiosPrivate,
    payload,
    pageNumber,
    pageSize
  ) => {
    return axiosPrivate.post(
      `${apiMapper.timesheet.empTimesheetTotalTimeoffHrsList}?page=${pageNumber}&page_size=${pageSize}`,
      payload
    );
  },
  TIMESHEET_APPROVER_SEARCH: (axiosPrivate, payload) => {
    return axiosPrivate.post(
      apiMapper.timesheet.timesheetApproverSearch,
      payload
    );
  },
  RECALL_TIMESHEET: (axiosPrivate, payload) => {
    return axiosPrivate.post(apiMapper.timesheet.recallTimesheet, payload);
  },

  UPDATE_TIMESHEET_BY_MANAGER: (axiosPrivate, payload) => {
    return axiosPrivate.post(
      apiMapper.timesheet.updateTimesheetByManager,
      payload
    );
  },
  UPDATE_TIMESHEET_BY_HR_MANAGER: (axiosPrivate, payload) => {
    return axiosPrivate.post(
      apiMapper.timesheet.updateTimesheetByHrManager,
      payload
    );
  },
  MISSING_TIMESHEETS: (axiosPrivate, payload) => {
    return axiosPrivate.post(apiMapper.timesheet.missingTimesheets, payload);
  },
  TIMESHEET_APPROVALS_ADMIN: (axiosPrivate, payload) => {
    return axiosPrivate.post(
      apiMapper.timesheet.timesheetApprovalsAdmin,
      payload
    );
  },
  UPDATE_TIMESHEET_BY_ADMIN: (axiosPrivate, payload) => {
    return axiosPrivate.post(
      apiMapper.timesheet.updateTimesheetByAdmin,
      payload
    );
  },
  EMPLOYEE_DAILY_TIMESHEET_REPORT: (axiosPrivate, payload) => {
    return axiosPrivate.post(
      apiMapper.timesheet.employeeDailyTimesheetReport,
      payload
    );
  },
  EXPORT_TIMESHEET: (axiosBlobPrivate, payload) => {
    return axiosBlobPrivate.post(apiMapper.timesheet.exportTimesheet, payload);
  },
  MISSING_TIMESHEET_REPORT: (axiosInstance, payload) => {
    return axiosInstance.post(
      apiMapper.timesheet.missingTimesheetsReport,
      payload,
      {
        responseType: "blob"
      }
    );
  },
  PLACEMENT_REPORT: (axiosPrivate, payload) => {
    return axiosPrivate.post(apiMapper.reports.placementReport, payload);
  },
  RIPPLING_DAILY_TIMESHEET_REPORT: (axiosBlobPrivate, payload) => {
    return axiosBlobPrivate.post(
      apiMapper.timesheet.ripplingDailyTimesheetReport,
      payload,
      {
        responseType: "blob"
      }
    );
  },
  SEND_REMINDER_EMAILS: (axiosPrivate, payload) => {
    return axiosPrivate.post(
      apiMapper.timesheet.missingTimesheetsReport,
      payload
    );
  },
  TRIGGER_TIMESHEET_NOTIFICATION: (axiosPrivate, payload) => {
    return axiosPrivate.post(
      apiMapper.timesheet.triggerTimesheetNotification,
      payload
    );
  },
  TIMESHEET_SUBMISSION_HISTORY: (
    axiosPrivate,
    pageNumber,
    pageSize,
    contractId,
    employeeId
  ) => {
    return axiosPrivate.get(
      `${apiMapper.timesheet.timesheetSubmissionHistory}?page=${pageNumber}&page_size=${pageSize}&sow_contract_id=${contractId}&employee_id=${employeeId}`
    );
  }
};

export default TimeSheetAPI;
